window.addEventListener("load", () => {
  const featuredProduct = $("home-featured-products[data-featured-products]");
  for (const item of featuredProduct) {
    var self = $(item),
      productGrid = self.find(".products-grid"),
      gridItemWidth = productGrid.data("row"),
      gridItemMobileWidth = productGrid.data("mobilerow"),
      hasRightSidebar = $(
        ".halo-product-content .pro-page [data-has-right-sidebar]"
      );

    const row = productGrid.data("row");
    const slidesToShow = hasRightSidebar.length ? 5 : row;
    const slidesToShow1400 = self.hasClass("has-banner") ? 3 : gridItemWidth > 5 ? 5 : row;
    let slidesToShow1200 = 2;
    if (!self.hasClass("has-banner")) {
      if (gridItemWidth >= 4) {
        slidesToShow1200 = 4;
      } else if ((gridItemWidth = 3)) {
        slidesToShow1200 = 3;
      }
    }
    const vertical = productGrid.hasClass("verticle");
    const slidesToScroll = productGrid.hasClass("verticle") ? 1 : row;
    let slidesToScroll1400 = 3;
    if (productGrid.hasClass("verticle")) {
      slidesToScroll1400 = 1;
    } else {
      if (gridItemWidth >= 4) {
        slidesToScroll1400 = 4;
      } else if ((gridItemWidth = 3)) {
        slidesToScroll1400 = 3;
      } else {
        slidesToScroll1400 = 2;
      }
    }
    let slidesToScroll1200 = 3;
    if (!self.hasClass("has-banner")) {
      if (gridItemWidth >= 4) {
        slidesToScroll1200 = 4;
      } else if ((gridItemWidth = 3)) {
        slidesToScroll1200 = 3;
      }
    }
    const dots = self.hasClass("has-banner");

    if (productGrid.not(".slick-initialized")) {
      productGrid.slick({
        draggable: true,
        slidesToShow: slidesToShow,
        vertical: vertical,
        slidesToScroll: slidesToScroll,
        speed: 1000,
        infinite: true,
        dots: dots,
        prevArrow:
          '<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="home-feapro-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="home-feapro-prev">Home Featured Product Prev</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>',
        nextArrow:
          '<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="home-feapro-next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="home-feapro-next">Featured Product Next</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>',
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: slidesToShow1400,
              slidesToScroll: slidesToScroll1400,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              dots: true,
              arrows: false,
              vertical: false,
              slidesToShow: slidesToShow1200,
              slidesToScroll: slidesToScroll1200,
            },
          },
          {
            breakpoint: 992,
            settings: {
              dots: true,
              arrows: false,
              vertical: false,
              slidesToShow: gridItemWidth >= 3 ? 3 : 2,
              slidesToScroll: gridItemWidth >= 3 ? 3 : 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: false,
              vertical: false,
              dots: true,
            },
          },
          {
            breakpoint: 590,
            settings: {
              slidesToShow: 2,
              slidesToShow: gridItemMobileWidth,
              slidesToScroll: gridItemMobileWidth != 2 ? 1 : 2,
              arrows: false,
              vertical: false,
              dots: true,
            },
          },
        ],
      });
    }
  }
});